/**
 * Labstep
 *
 * @module components/Signature/Form/fields
 * @desc Signature fields
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules from 'labstep-web/services/validation/rules';

export const fieldSignatureStatement: FieldWithoutActionProps = {
  name: 'statement',
  fieldLabel: 'Statement',
  fieldType: FieldType.TextArea,
  validation: rules.signature.statement,
};

export const getFieldSignatureRequirementEntityStateOnReject = (
  options: any,
): FieldWithoutActionProps => {
  return {
    name: 'reject_entity_state',
    fieldLabel: 'Change Experiment Status To',
    fieldType: FieldType.ReactSelect,
    elementProps: {
      options,
    },
    validation: rules.signature_requirement.reject_entity_state,
  };
};
